export class KeyBinding {
    operation: string
    keys: string[]

    constructor(operation: string, keys: string[]) {
        this.operation = operation
        this.keys = keys
    }
}
